import _ from 'lodash';
import {
  getLeadModules,
  isWebOptionEnabled,
} from 'src/models/lmsConfig/queries';

const getLeadModulesForAdd = (allInputs) => {
  const modules = getLeadModules();

  return modules
    .filter(
      (item) =>
        !_.isEmpty(allInputs[item.start_state]) &&
        isWebOptionEnabled('hide_add', 'add_lead', item.start_state),
    )
    .map((item) => ({
      name: item.name,
      code: item.start_state,
    }));
};

export const getAddLeadInputs = (values, allInputs, module) => {
  const inputs: any = [];
  if (_.isEmpty(module)) {
    const leadModules = getLeadModulesForAdd(allInputs);
    inputs.push({
      code: 'vymo_lead_select',
      hint: 'Where would you like to create a new record?',
      type: 'code_name_spinner',
      code_name_spinner_options: [...leadModules],
      required: true,
    });
  }

  const selectedModule =
    values?.vymo_lead_select?.additionalData?.data?.code || module.start_state;

  if (selectedModule) {
    inputs.push(...(allInputs[selectedModule] || []));
  }
  return inputs;
};
